module.exports = __webpack_public_path__ + "resources/img/img_sqml_di1_m_en.edd5586e9af42a19730cc69684006abd.png";